{
  "project": "Project",
  "node": "Plan node",
  "category": "Cost category",
  "projectOf": "Project of {{what}}",
  "nodeOf": "Plan node of {{what}}",
  "categoryOf": "Cost category of {{what}}",
  "chooseProject": "Choose a project",
  "noProject": "No project",
  "searchProjects": "Search projects by code or name…",
  "noProjects": "No open project matches.",
  "noRevenueProjects": "No open project of this customer matches.",
  "projectsError": "Projects could not be loaded.",
  "wholeProject": "The whole project",
  "searchNodes": "Search the plan…",
  "noNodes": "No plan node matches.",
  "auto": "Set automatically",
  "autoHint": "Left empty, the category comes from the company’s cost mapping when the document is saved.",
  "autoIs": "Automatic: {{category}}",
  "autoFromSource": "Automatic (from the product or account)",
  "autoFromExpense": "Automatic (from the expense category)",
  "noCategories": "No category matches.",
  "searchCategories": "Search categories…",
  "archived": "archived",
  "tag": "Project {{project}}",
  "column": "Project",
  "moreProjects_one": "+{{count}} more",
  "moreProjects_other": "+{{count}} more",
  "filter": "Filter by project",
  "allProjects": "All projects",
  "deliveredToSite": "Delivered to site: no stock movement",
  "deliveredToSiteHint": "The goods go straight to the project: posting charges its cost account instead of stock.",
  "reducesCost": "Reduces {{project}}’s cost",
  "serialBlocked": "Serial-tracked goods can’t be tagged to a project: receive them into stock, then issue them to the project.",
  "notTaggedSerial": "Not tagged: serial goods",
  "forAllLines": "Project for all lines",
  "forAllLinesHint": "Sets the project on every line; a line can still change its own.",
  "linesMixed": "Lines on several projects",
  "more": "More",
  "moreOf": "More for line {{n}}: project, plan node and cost category",
  "lineN": "line {{n}}",
  "lineLabel": "Line {{n}}",
  "copiedTag": "From the purchase line: {{tag}}",
  "section": "Project",
  "sectionHint": "The project this cost belongs to. Its account and posting don’t change.",
  "errors": {
    "PROJECT_NOT_OPEN": "The project is closed or cancelled: choose an open project.",
    "PROJECT_SERIAL_GOODS": "Serial-tracked goods can’t be tagged to a project: receive them into stock, then issue them to the project.",
    "PROJECTS_MODULE_OFF": "Projects is turned off for your company: a new project tag can’t be set.",
    "PROJECT_FEATURE_OFF": "The project doesn’t use a plan: leave the plan node empty."
  }
}
